import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DuplicateCheckField from './../../../reusable/Form/DuplicateCheckFieldBlur';
import api from './../../../api/Categories.api';
import { MAX_CATEGORY_NAME_LENGTH } from './../../../constants'

class CategoryName extends Component {
    static propTypes = {
        initialValue: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        categoryId: PropTypes.string,
        maxLength: PropTypes.number,
        isRequired: PropTypes.bool,
        inputProps: PropTypes.object
    };

    static defaultProps = {
        initialValue: "",
        categoryId: null,
        maxLength: MAX_CATEGORY_NAME_LENGTH,
        isRequired: true,
        inputProps: {}
    };

    messageIds = {
        labelId: 'Category_Create_UIText_addCategory.categoryName',
        placeholderId: 'Category_Create_UIText_addCategory.categoryName.placeholder',
        errorMessageId: 'RSS_Add_Error_addRssFeed.feedInfo.unavailableNameError',
    };

    render = () =>  <DuplicateCheckField messageIds={this.messageIds}
                                         initialValue={this.props.initialValue}
                                         duplicateCheckRequest={api.validateNameField}
                                         onChange={this.props.onChange}
                                         itemId={this.props.categoryId} // TODO: can be moved
                                         maxLength={this.props.maxLength}
                                         isRequired={this.props.isRequired}
                                         inputProps={this.props.inputProps} />
}

export default CategoryName;


// WEBPACK FOOTER //
// ./src/scripts/pages/Categories/Components/CategoryName.jsx